import type { ReactNode } from 'react';
import { Fragment } from 'react';

import type { CraftEmailTimelineItem } from '../../../../features/craft-email-agent/types';
import { AIOutreachResult } from '../AIOutreachResult';

import {
  StyledAiText,
  StyledChatMessages,
  StyledChatMsg,
  StyledTypingBubble,
  StyledTypingDot,
  StyledTypingRow,
  StyledUserBubble,
} from './styles';

const renderTextWithBold = (text: string): ReactNode => {
  const parts = text.split(/\*\*/);
  return parts.map((part, i) => (i % 2 === 1 ? <strong key={i}>{part}</strong> : <Fragment key={i}>{part}</Fragment>));
};

type AIOutreachTimelineProps = {
  items: CraftEmailTimelineItem[];
  showTyping: boolean;
  threadId: string | null;
  setUserMessageAnchor: (id: string, el: HTMLElement | null) => void;
};

export const AIOutreachTimeline = ({ items, showTyping, threadId, setUserMessageAnchor }: AIOutreachTimelineProps) => {
  return (
    <StyledChatMessages data-automation="AIOutreachTimeline">
      {items.map((item) => {
        if (item.kind === 'chat') {
          return item.role === 'user' ? (
            <StyledChatMsg
              key={item.id}
              ref={(el) => setUserMessageAnchor(item.id, el)}
              $role="user"
              data-ai-outreach-scroll-anchor={item.id}
            >
              <StyledUserBubble>{item.content}</StyledUserBubble>
            </StyledChatMsg>
          ) : (
            <StyledChatMsg key={item.id} $role="assistant">
              <StyledAiText>{renderTextWithBold(item.content)}</StyledAiText>
            </StyledChatMsg>
          );
        }

        return (
          <AIOutreachResult
            key={item.id}
            emailPreview={item.preview}
            displayBodyBefore={item.preview.bodyBefore}
            displayBodyAfter={item.preview.bodyAfter}
            threadId={threadId}
            messageId={item.streamMessageId}
          />
        );
      })}
      {showTyping ? (
        <StyledTypingRow data-automation="AIOutreachChatTyping">
          <StyledTypingBubble>
            <StyledTypingDot $delay={0} />
            <StyledTypingDot $delay={150} />
            <StyledTypingDot $delay={300} />
          </StyledTypingBubble>
        </StyledTypingRow>
      ) : null}
    </StyledChatMessages>
  );
};
